export type UserType = "ops" | "partner" | "internal";

const OPS_TEAM_IDS = [254298, 206364, 245718];

export function getUserType(
  userId: number | undefined,
  isExternal: boolean = false,
): UserType {
  if (!userId) return "internal";

  if (OPS_TEAM_IDS.includes(userId)) {
    return "ops";
  }

  if (isExternal) {
    return "partner";
  }

  return "internal";
}

export function shouldShowModal(userType: UserType): boolean {
  return userType !== "ops";
}

const LIFECYCLE_FIELDS = new Set<string>([
  "status",
  "lifecycleState",
  "availabilityDate",
]);

type ComparableData = {
  [key: string]: unknown;
  photos?: { url?: string }[];
  videoUrls?: string[];
  selectedAmenities?: { amenityId: string; status: string }[];
  operatingHours?: unknown;
};

export function isLifecycleOnlyChange(
  currentData: ComparableData,
  originalData: ComparableData,
): boolean {
  const scalarFields = [
    "name",
    "description",
    "notes",
    "capacity",
    "size",
    "monthlyPrice",
    "timezone",
  ];

  for (const field of scalarFields) {
    if (
      String(currentData[field] ?? "").trim() !==
      String(originalData[field] ?? "").trim()
    ) {
      return false;
    }
  }

  const currentPhotos = (currentData.photos ?? [])
    .map((p) => p.url ?? "")
    .sort();
  const originalPhotos = (originalData.photos ?? [])
    .map((p) => p.url ?? "")
    .sort();
  if (JSON.stringify(currentPhotos) !== JSON.stringify(originalPhotos)) {
    return false;
  }

  const currentVideo = currentData.videoUrls?.[0] ?? "";
  const originalVideo = originalData.videoUrls?.[0] ?? "";
  if (currentVideo !== originalVideo) {
    return false;
  }

  const currentAmenities = (currentData.selectedAmenities ?? [])
    .map((a) => ({ id: a.amenityId ?? "", status: a.status }))
    .sort((a, b) => a.id.localeCompare(b.id));
  const originalAmenities = (originalData.selectedAmenities ?? [])
    .map((a) => ({ id: a.amenityId ?? "", status: a.status }))
    .sort((a, b) => a.id.localeCompare(b.id));
  if (JSON.stringify(currentAmenities) !== JSON.stringify(originalAmenities)) {
    return false;
  }

  if (
    JSON.stringify(currentData.operatingHours) !==
    JSON.stringify(originalData.operatingHours)
  ) {
    return false;
  }

  void LIFECYCLE_FIELDS;
  return true;
}
